import React, { useMemo, useState } from "react";
import { Empty, Table } from "antd";
import { useQuery } from "@apollo/client";
import { GET_TRANSLATION_AI_USAGE_DAILIES, GET_TRANSLATION_AI_USAGE_DAILY_TOTAL } from "graphql/query/translation-ai-gql";
import Settings from "components/settings";
import { PageWrapDefault } from "components/layout";
import { Localize } from "components/service";
import { useActiveMenuItem, useBreadCrumbs, useDebounce } from "components/use-hooks";
import TranslationAiTotalSummary from "./translation-ai-total-summary";

import './settings.scss';


const routeUrl = Settings.Const.translationAiUsagePath;
const tableHelper = Settings.Helpers.TranslationAiTable.Usage;

const TranslationAiUsagePage = () => {

    useActiveMenuItem([ "settings-translation-ai-usage" ], [ "settings" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Settings" }).props.children,
            path: `${ Settings.Const.basePath }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_TranslationAiUsage" }).props.children,
            path: `${ routeUrl }`
        }
    ];

    useBreadCrumbs(breadcrumbs);

    const [ searchText, setSearchText ] = useState("");
    const [ filters, setFilters ] = useState();
    const debouncedSearchText = useDebounce(searchText);

    const { data, loading } = useQuery(GET_TRANSLATION_AI_USAGE_DAILIES, {
        variables: {
            text: debouncedSearchText,
            first: 25,
            page: 1,
            where: filters,
            orderBy: [ { column: "DATE_AT", order: "DESC" } ],
        },
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first'
    });

    const { data: totalData, loading: totalLoading } = useQuery(GET_TRANSLATION_AI_USAGE_DAILY_TOTAL, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first'
    });

    const records = useMemo(() => (
        data?.translateAiUsageDailies?.data || []
    ), [ data ]);

    const total = useMemo(() => (
        totalData?.translateAiUsageDailyTotal
    ), [ totalData ]);

    return (
        <PageWrapDefault
            className="page-settings page-translation-ai-usage"
            dataExist={ true }
            title={ <Localize>PAGES.Title_TranslationAiUsage</Localize> }
        >
            <TranslationAiTotalSummary
                loading={ totalLoading }
                total={ total }
            />

            <div className="translation-ai-analytics-layout">
                <div className="translation-ai-table-panel">
                    <div className="table-action-bar">
                        <div className="col">
                            <Settings.Filters.TranslationAiTable
                                setSearchText={ setSearchText }
                                setFilters={ setFilters }
                                dateColumn="DATE_AT"
                                searchPlaceholder="SEARCH.Input_Placeholder_TranslationAiUsage" />
                        </div>
                    </div>
                    <Table
                        className="table-main translation-ai-compact-table"
                        locale={ {
                            emptyText: (
                                <div className="no-data-box">
                                    <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } />
                                    <span className="no-data-text"><Localize>GLOBAL.Text_NoData</Localize></span>
                                </div>
                            ),
                        } }
                        dataSource={ tableHelper.data(records) }
                        columns={ tableHelper.columns }
                        tableLayout="auto"
                        size="middle"
                        loading={ loading }
                        pagination={ false } />
                </div>
                <div className="translation-ai-chart-panel">
                    <Settings.Charts.TranslationAi.Usage records={ records } />
                </div>
            </div>
        </PageWrapDefault>
    );
};

export default TranslationAiUsagePage;
